const th = {
    l: {
        en: "English",
        th: "ไทย",
        lo: "ลาว"
    },
    language: "ภาษา",
    lang : "ไทย",
    signIn : "เข้าสู่ระบบ",
    fill_user_pass : "กรุณาป้อนข้อมูลสมาชิก",
    logout : "ออกจากระบบ",
    register : "ลงทะเบียน",
    menu: {
        dashboard: "แผงควบคุม",
        transection: "รายการทำรายการล่าสุด",
        profile: "โปรไฟล์",
        showqr: "แสดง QRCode",
        change_password: "เปลี่ยนรหัสผ่าน",
        init_doc: "เริ่มจัดสินค้า",
        shipment_check: "ตรวจสอบใบจัดส่งสินค้า",
        ship_parcel: "รับพัสดุนำส่ง",
        drop_parcel: "บันทึกส่งพัสดุ",
        move_parcel: "รอบการส่ง",
        drop_image_confirm: "ยืนยันภาพใบทัวร์",
    },
    dashboard : {
        advance_money_balance: "เงินล่วงหน้าคงเหลือ",
        point_balance: "แต้มคงเหลือ",
        advance_money_transection: "รายการเงินล่วงหน้า",
        point_transection : "รายการแต้ม",
        nodata: "ไม่มีข้อมูล",
        today_packing: "จัดสินค้า",
        today_picking: "ส่งสินค้า"
    },
    trans_flag : {
        trans_flag_40 : "จ่ายเงินล่วงหน้า",
        trans_flag_44 : "ชำระค่าสินค้า/บริการ"
    },
    profile: {
        name: "ชื่อ",
        username: "รหัสผู้ใช้งาน",
        password: "รหัสผ่าน",
        email: "อีเมล",
        change_password: "เปลี่ยนรหัสผ่าน",
        current_password: "รหัสผ่านปัจจุบัน",
        new_password: "รหัสผ่านใหม่",
        confirm_password: "ยืนยันรหัสผ่าน",
        not_scure_password: "รหัสผ่านไม่ปลอดภัย กรุณาเปลี่ยนรหัสผ่าน",
        confirm_password_invalid: "รหัสผ่าน ยืนยันไม่ถูกต้อง",
        input_invalid: "ป้อนข้อมูลผิด"
    },
    common: {
        save: "บันทึก",
        save_success: "บันทึกสำเร็จ",
        save_fail: "บันทึกล้มเหลว"
    },
    Boxs: "กล่อง",
    Sended: "ส่ง"
}

export default th